import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { AccountMenu } from "./Component/AccountMenu";
import "../node_modules/video-react/dist/video-react.css";
import { useUser } from "./Provider/UserProvider";
import "./Component/Asset.css";
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { OrganizationMemberSelectBox } from "./Component/OrganizationMemberSelectBox";
import { Grid } from "@mui/material";
import Modal from "./Component/Modal";
import { API_DOMAIN_URL } from "./Common";

export function ImportMembersCsv() {
  const navigate = useNavigate();
  const { user } = useUser();
  const [organizationUsers, setOrganizationUsers] = useState(null);
  const [orgUser, setOrgUser] = useState();

  const authCheck = () => {
    if (!user || !user.id || user.id == "error") {
      navigate("/SignIn");
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (authCheck()) {
      getOrganizationUsers();
    }
  }, []);

  const getOrganizationUsers = () => {
    // get organization users data
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/GetOrganizationUsers?code=${code}&UserId=${user.id}`;
    //console.log(url);
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);
        //response.push(user);
        setOrganizationUsers(response);
      })
      .catch(() => {
        //console.error();
        console.log("ImportMembersCsv OrganizationUsers Exception");
        let orgUsers = [];
        orgUsers.push(user);
        setOrganizationUsers(orgUsers);
      });
  };

  const getSexValue = (sexText) => {
    switch (sexText.trim()) {
      case "男":
      case "1":
        return 1;
      case "女":
      case "2":
        return 2;
      default:
        return parseInt(sexText);
    }
  };

  const getCareLevelValue = (careLevelText) => {
    let value = "";
    switch (careLevelText) {
      case "":
      case "0":
        value = 0;
        break;
      case "要支援１":
        value = 1;
        break;
      case "要支援1":
        value = 1;
        break;
      case "要支援２":
        value = 2;
        break;
      case "要支援2":
        value = 2;
        break;
      case "要介護１":
        value = 3;
        break;
      case "要介護1":
        value = 3;
        break;
      case "要介護２":
        value = 4;
        break;
      case "要介護2":
        value = 4;
        break;
      case "要介護３":
        value = 5;
        break;
      case "要介護3":
        value = 5;
        break;
      case "要介護４":
        value = 6;
        break;
      case "要介護4":
        value = 6;
        break;
      case "要介護５":
        value = 7;
        break;
      case "要介護5":
        value = 7;
        break;
    }

    return value;
  };

  const parseBirthdayToDate = (birthdayStr) => {
    if (!birthdayStr) return null;
    const eraMap = { "明治": 1867, "大正": 1911, "昭和": 1925, "平成": 1988, "令和": 2018 };
    let str = birthdayStr.trim();
    for (const [era, baseYear] of Object.entries(eraMap)) {
      if (str.startsWith(era)) {
        const parts = str.slice(era.length).split(".");
        if (parts.length !== 3) return null;
        return new Date(baseYear + parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      }
    }
    const parts = str.split(".");
    if (parts.length === 3) {
      return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
    }
    const d = new Date(str);
    return isNaN(d.getTime()) ? null : d;
  };

  const csvparse = (text, orgUserId) => {
    try {
      let finalObj = {};
      let memberAry = [];
      let parseError = null;

      let recordAry = text.split("\n");
      for (let record of recordAry) {
        let cells = record.split(",");

        if (cells.length == 8) {
          let addingMember = {};
          addingMember.UserName = crypto.randomUUID();
          addingMember.NickName = cells[0];
          if (!addingMember.NickName) {
            parseError = "表示名が入力されていない行があります";
            break;
          }
          if (addingMember.NickName.length > 100) {
            parseError = "表示名が100文字を超えている行があります";
            break;
          }
          addingMember.Furigana = cells[1];
          if (!addingMember.Furigana) {
            parseError = "ふりがなが入力されていない行があります";
            break;
          }
          if (addingMember.Furigana.length > 100) {
            parseError = "ふりがなが100文字を超えている行があります";
            break;
          }
          if (!/^[ぁ-ん\u3000 ー]+$/.test(addingMember.Furigana)) {
            parseError = "ふりがなはひらがなで入力してください";
            break;
          }
          addingMember.Sex = getSexValue(cells[2]);
          if (isNaN(addingMember.Sex) || addingMember.Sex === 0) {
            parseError =
              "性別が正しく入力されていない行があります（男・女・1・2 のいずれかを入力してください）";
            break;
          }
          addingMember.Birthday = cells[3];
          if (!addingMember.Birthday) {
            parseError = "誕生日が入力されていない行があります";
            break;
          }
          const birthdayDate = parseBirthdayToDate(addingMember.Birthday);
          if (birthdayDate) {
            const threshold = new Date();
            threshold.setFullYear(threshold.getFullYear() - 3);
            if (birthdayDate > threshold) {
              parseError = "誕生日は3年以上前の日付を入力してください";
              break;
            }
          }
          addingMember.BodyHeight = parseFloat(cells[4]);
          if (isNaN(addingMember.BodyHeight)) {
            parseError =
              "身長が入力されていない行があります（数値を入力してください）";
            break;
          }
          if (addingMember.BodyHeight <= 0) {
            parseError = "身長は0より大きい値を入力してください";
            break;
          }
          addingMember.BodyWeight = parseFloat(cells[5]);
          if (isNaN(addingMember.BodyWeight)) {
            parseError =
              "体重が入力されていない行があります（数値を入力してください）";
            break;
          }
          addingMember.Prefecture = cells[6] === "0" ? "" : cells[6];
          addingMember.CreateUserId = orgUserId;
          addingMember.CareLevel = getCareLevelValue(
            cells[7].replace("\r", "")
          );

          memberAry.push(addingMember);
        }
      }

      if (parseError) return { error: parseError };
      finalObj.Members = memberAry;
      return finalObj;
    } catch {
      return false;
    }
  };

  const uploadCsv = (bodyObj) => {
    let jsonString = JSON.stringify(bodyObj);

    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/CreateSubMemberS?code=${code}&SampleGroupId=${user.SampleGroupId}`;

    fetch(url, {
      method: "POST",
      body: jsonString,
    }).then(
      function (response) {
        if (response.status == 200) {
          successModalOpen();
        } else {
          errorModalOpen("サーバーへの保存に失敗しました");
        }
      },
      function (error) {
        console.log(error);
        errorModalOpen("サーバーへの保存に失敗しました");
      }
    );
  };

  const fileUpload = () => {
    const file = document.getElementById("csvFile").files[0];
    if (!file) {
      errorModalOpen("CSVファイルを選択してください");
      return;
    }
    if (!orgUser) {
      errorModalOpen("アップロード先を選択してください");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      let obj = csvparse(e.target.result, orgUser.id);
      if (obj && obj.error) {
        errorModalOpen(obj.error);
      } else if (obj && obj.Members && obj.Members.length >= 1) {
        uploadCsv(obj);
      } else {
        errorModalOpen(
          "有効なデータが見つかりませんでした。"
        );
      }
    };

    reader.readAsText(file, "shift-jis");
  };

  const downloadFromUrlAutomatically = (url, fileName) => {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function (e) {
      if (this.status == 200) {
        var urlUtil = window.URL || window.webkitURL;
        var imgUrl = urlUtil.createObjectURL(this.response);
        var link = document.createElement("a");
        link.href = imgUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      console.log(e);
    };
    xhr.send();
  };

  const sampleFileDownload = () => {
    downloadFromUrlAutomatically(
      "https://devseniorquality8937.blob.core.windows.net/sample/sample.csv",
      "sample.csv"
    );
  };

  // 更新完了確認のモーダル
  const [successModalStatus, setSuccessModalStatus] = React.useState(false);
  const successModalOpen = () => {
    setSuccessModalStatus(true);
  };
  const successModalClose = () => {
    setSuccessModalStatus(false);
  };

  // エラーモーダル
  const [errorModalStatus, setErrorModalStatus] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const errorModalOpen = (message) => {
    setErrorMessage(message);
    setErrorModalStatus(true);
  };
  const errorModalClose = () => {
    setErrorModalStatus(false);
  };

  const commonStyles = {
    bgcolor: "background.paper",
    border: 1,
    borderColor: "#bdbdbd",
  };

  return (
    <div className="asset-list-root">
      <AccountMenu />
      <Container component="main" maxWidth="md">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item md={4}>
              <Typography component="h1" variant="h5">
                CSVファイル取り込み
              </Typography>
            </Grid>
            <Grid item md={8}></Grid>

            <Grid item md={3} mt={1}>
              <Typography variant="body2">アップロード先</Typography>
              <OrganizationMemberSelectBox
                orgUsers={organizationUsers}
                setOrgUser={setOrgUser}
                setShowAddBtn={null}
              />
            </Grid>
            <Grid item md={9} mt={1}></Grid>
            <Grid item md={12} mt={1}>
              <Typography variant="body2">
                CSVファイルを選択してください
              </Typography>
              <input type="file" accept=".csv" id="csvFile" />
            </Grid>
            <Button
              variant="contained"
              color="success"
              sx={{ mt: 2 }}
              align
              onClick={() => fileUpload()}
            >
              CSV読み込み
            </Button>
          </Grid>
        </Box>
        <Grid
          container
          direction="coloum"
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{ ...commonStyles, p: 2, mt: 2 }}
        >
          <Grid item md={12}>
            <Typography variant="body2">
              CSVフォーマットデータ（サンプル）のダウンロード
            </Typography>
          </Grid>
          <Grid item md={12}>
            <Button
              variant="contained"
              color="primary"
              sx={{ pr: "50px", pl: "50px" }}
              onClick={() => sampleFileDownload()}
            >
              サンプルのダウンロード
            </Button>
          </Grid>
          <Grid item md={12} mt={2}>
            <Typography variant="h6">項目の説明</Typography>
          </Grid>
          <Grid item md={12} mb={1}>
            <Typography variant="body2">
              全ての欄に値が必須です。数値は半角で記入してください。
            </Typography>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid item md={2}>
              <Typography variant="body2">列Ａ 名前</Typography>
            </Grid>
            <Grid item md={10}>
              <Typography variant="body2">
                ▸ メンバーの表示名です。
              </Typography>
            </Grid>
          </Grid>

          <Grid item md={2}>
            <Typography variant="body2">列Ｂ ふりがな</Typography>
          </Grid>
          <Grid item md={10}>
            <Typography variant="body2">
              ▸ ひらがなで入力してください。
            </Typography>
          </Grid>

          <Grid item md={2}>
            <Typography variant="body2">列Ｃ 性別</Typography>
          </Grid>
          <Grid item md={10}>
            <Typography variant="body2">
              ▸ 1:男性 2:女性の1または2で数値入力でも可。
            </Typography>
          </Grid>

          <Grid item md={2}>
            <Typography variant="body2">列Ｄ 誕生日</Typography>
          </Grid>
          <Grid item md={10}>
            <Typography variant="body2">
              ▸ 例：昭和45.01.01&nbsp;または&nbsp;1970.01.01（少なくとも現在より３年以上前の日付を入力してください。区切り文字は . でお願いします。）
            </Typography>
          </Grid>

          <Grid item md={2}>
            <Typography variant="body2">列Ｅ 身長 cm</Typography>
          </Grid>
          <Grid item md={10}>
            <Typography variant="body2">
              ▸ 小数点以下第１位まで入力可能です。測定値の計算に使用しますので0は不可です。
            </Typography>
          </Grid>

          <Grid item md={2}>
            <Typography variant="body2">列Ｆ 体重 kg</Typography>
          </Grid>
          <Grid item md={10}>
            <Typography variant="body2">
              ▸ 小数点以下第１位まで入力可能です（登録を希望しない方は0も入力することができます。）
            </Typography>
          </Grid>

          <Grid item md={2}>
            <Typography variant="body2">列Ｇ 都道府県</Typography>
          </Grid>
          <Grid item md={10}>
            <Typography variant="body2">
              ▸ 施設が所在する都道府県を入力してください（登録を希望しない方は0も入力することができます。）
            </Typography>
          </Grid>

          <Grid item md={2}>
            <Typography variant="body2">列Ｈ 介護度</Typography>
          </Grid>
          <Grid item md={10}>
            <Typography variant="body2">
              ▸ 要支援１、要支援２、要介護１、要介護２、要介護３、要介護４、要介護５（該当なし、または登録を希望しない方は0も入力することができます。）
            </Typography>
          </Grid>
        </Grid>
        <Box sx={{ mb: 4 }} />
      </Container>
      <Modal
        title={"エラー"}
        message={errorMessage}
        status={errorModalStatus}
        okBtnCallback={errorModalClose}
      />
      <Modal
        title={"登録成功"}
        message={"CSV読み込みによる登録が完了しました"}
        status={successModalStatus}
        okBtnCallback={successModalClose}
      />
    </div>
  );
}
